<script>
    import { navigating } from '$app/stores';
    import { PURGE_DAYS } from "$lib/universal/lib.js";
    import { keydownWrapper } from '$lib/app/lib.js';

    import LoginMenu from '$lib/LoginMenu.svelte';
    import PageLoader from '$lib/PageLoader.svelte';
    import LoginSignupForm from '$lib/LoginSignupForm.svelte';
    
    let {
        session = null,
        authentication_required = false,
        show_signup = $bindable(false),
        show_login = $bindable(false)
    } = $props();

    $effect(() => {
        if(authentication_required) {
            if((!session || !session?.id)) {
                show_signup = false; show_login = true;
            } else {
                show_signup = show_login = false;
            }
        }
    });

    let purge_after = $state(null);

    if(session?.deleted) {
        const daysBeforePurge = Math.floor((PURGE_DAYS*60*60*24 - (Date.now()/1000 - session.deleted)) / (60*60*24));
        const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });
        purge_after = daysBeforePurge <= 0 ? 'anytime now' : rtf.format(daysBeforePurge, 'days');
    }

    function burger(e) {
        const data_target = document.getElementById(e.currentTarget.dataset.target);
        e.currentTarget.classList.toggle('is-active');
        data_target.classList.toggle('is-active');
    } 

    let all_hoverables = null;
    
    function handleMenuClick(event) {     
        if(!all_hoverables)
            all_hoverables = document.querySelectorAll(".is-hoverable");
        if(all_hoverables) {
            all_hoverables.forEach((el) => {  el.classList.remove("is-hoverable"); });
            window.addEventListener("mousemove", handleMouseMove, { once: true });
        }
    }

    function handleMouseMove() {
        if(all_hoverables) {
            all_hoverables.forEach((el) => { el.classList.add("is-hoverable"); });
            all_hoverables = null;
        }
    }
</script>


{#if $navigating}
<PageLoader/>
{/if}
<nav id="main-menu" class="navbar" aria-label="main navigation">
    <div class="navbar-brand">
        <a class="navbar-item logo pl-0" href="/">
            <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 512 512" width="96px" height="96px">
                <path fill="#F6A192" d="M376.2 227.8c.8-3.6-.6-8.3-1.3-11.9-1-4.8-1.8-9.5-2.6-14.3-1.9-11.1-3.7-22.1-6.5-33-5.6-21.7-12.5-43-20.3-63.9 0-.1 0-.1 0-.2-5.9-5.5-13.9-9.3-22-8.3-19.6 2.4-19.8 24.7-20.3 39.9-.3 8.1-.9 18.5-7 24.6-5.4 5.4-13.6 7-20.9 5 4.1 12.4 7.7 25 10.8 37.6 3.1 12.5 6.1 25 9.5 37.4 1.4 5.1 2.8 10.3 4.5 15.3.6 1.8 1.2 3.6 1.9 5.3 0 0 0 .1 0 .1 1.9 1.5 2.6 4.4 1.7 6.7.4.7.8 1.4 1.2 2.1 3 5.6 5.4 11.8 9.6 16.7 2.3 2.7 6.2 6.7 10.1 6.7 6.8-.1 12-6.8 15.4-12 4.7-7.2 8.3-15 11.7-22.8 3.7-8.6 6.8-18.4 14.5-24.4 3.2-2.5 6.7-3.6 10.2-3.7C376 229.7 376 228.8 376.2 227.8zM286.7 250.6c-3.7-13.2-7-26.6-10.3-40-4.7-18.9-10.2-37.5-16.8-55.7-4.4-5-7.8-10.9-10.5-17-4.8-10.9-5.9-23.1-10.8-34C233 92.3 223.2 84.3 210.4 83c-11.4-1.2-23 1.7-33.6 5.9-18.5 7.3-40.7 21.1-42.8 42.9-.4 4.2-4.4 5.1-7.4 3.7 3.2 9.4 7.8 18.2 11.6 27.4 9 21.9 17.9 43.7 27.1 65.5 10.3 24.3 22.2 47.8 34.5 71.1 7.4-11.8 16.6-22.6 28-30.7 11.9-8.4 27-16.6 41.7-17.8 6.6-.6 12.6.4 18 2.7C287.2 252.4 287 251.4 286.7 250.6z"/>
                <path fill="#127274" d="M292.2,479c-5.1-9.5-12.4-17.6-18.1-26.7c-34.2-54.9-65.1-111.7-95.2-168.9c-14.8-28.1-26.6-57.5-38.7-86.8c-6.1-14.6-11.7-29.6-18.4-43.9c-2.8-5.9-4.9-11.8-7.1-18c-1.8-4.9-3.7-10.1-7.7-13.7c-2.8-2.6-2-6.2,0.2-8.2c0-1.2,0.4-2.4,1.3-3.6c2.1-2.5,4.8-3.2,7.2-5.1c1.5-1.2,1.3-4.5,1.2-6.2c-0.3-3.6-1.8-8.3-5.4-10c-7.8-3.7-18.9,0.5-25.6,4.9c-6.6,4.4-11.8,11.4-9.3,19.7c0.8,2.7,2.1,5.6,4.9,6.7c2,0.7,4.2-0.3,6.1-1.6c0.5-0.5,1-0.9,1.5-1.2c0.5-0.4,1-0.8,1.4-1.1c4.9-4.2,10.4,3.1,7.3,7.8c0,0,0,0.1,0,0.1c0.3,0.7,0.5,1.3,0.8,2c1,2.2,2,4.3,3,6.5c3.4,7,7,13.9,10.2,21c6.3,14.4,12.2,28.9,18.7,43.2c6.6,14.5,13.6,28.8,20.2,43.2c6.6,14.3,12.5,28.9,19.8,42.9c7.1,13.6,14.6,27,21.5,40.7c14.4,28.5,27,57.9,40.3,86.9c12.3,26.7,27.7,52,42.9,77.2c0,0,0,0,0,0c0.5,0.6,0.9,1.2,1.3,1.8c0.9-0.4,2-0.5,3.2-0.1c3.9,1,9.8,1.7,13.3-0.8C295.6,485.7,293.4,481.3,292.2,479z"/>
                <path fill="#F6A192" d="M415,202.3c-3,0.5-5.7-2.3-5.9-5.1c-1.1-13.6,1.7-27.3,6.2-40.1c2.2-6.3,4.8-12.4,8.1-18.3c-3,1.8-6,3.5-9,5.1c-9,4.7-19.3,10.1-29.6,11c-4.8,0.4-8.7-0.6-12-2.6c1.7,6,3.3,12.1,4.7,18.1c2.7,11.2,4.3,22.6,6.3,33.9c1.4,7.8,5,17.6,3.2,25.5c-0.3,1.3-1,2.3-1.8,3c3.3,1.8,6.3,4.5,8.6,7.8c4.4,6.2,6.2,15.6,12.3,20.5c7.8,6.2,14.8-5,17.8-10.9c4.9-9.4,8.7-19,15.8-27.1c7.8-8.8,16.8-16.4,24.7-25.1C448.8,193.7,430.1,199.6,415,202.3z"/>
                <path d="M476,190.9c-17.1-9.1-37.8-4.3-56.2-0.6c0.1-21.1,8.9-44.6,22.9-59.8c1.4-1.6,1.6-3.4,1.1-5.1c0.7-0.5,1.3-1.1,1.9-1.9c3.4-4.8-1.8-12.1-7.2-8.2c-11.1,8.1-22.6,16-35.1,22c-5.7,2.7-11.6,4.9-17.7,6.4c-3.5,0.8-6.5,0.5-9.2-1.8c-5.7-5-7.6-14.6-9.8-21.4c-3.1-9.4-7.1-17.6-14.5-24.4c-8.6-8-20.9-12.3-32.6-10.3c-11.2,2-19.2,9.6-23.4,20c-3.8,9.4-4.2,19.4-4.3,29.4c-0.1,6,0.1,17.1-6.6,19.9c-6,2.5-11.8-1.2-16.1-5.6c-5.5-15-11.7-29.8-18.6-44.2c-0.2-0.4-0.4-0.8-0.7-1.1c-2.2-5.7-4.9-11.2-8.8-16c-6.9-8.5-16.6-13.7-27.4-15.5c-19.5-3.2-40.2,4.4-57,13.9c-15.4,8.7-30.5,22.7-33.4,40.8c-1.6-4-3.6-7.9-6.3-11.2c2.5-2.6,6.2-3.3,8.3-6.6c1.9-3,2.2-6.4,2.4-9.8c0.4-7.1-2.7-14.1-7.9-18.9c-10.7-10-29.7-3.5-40.3,3.2c-11.7,7.3-17.6,20.8-13,34.1c1.9,5.5,6.3,10.4,12,11.9c3.3,0.9,6.6,0.6,9.7-0.5c0.1,0.1,0.1,0.2,0.2,0.3c4.5,10.1,9.8,19.9,14.3,30c6.3,14.4,12.3,29,18.8,43.3c6.6,14.5,13.6,28.8,20.2,43.3c6.4,14,12.4,28.2,19.4,41.9c7.1,13.8,14.7,27.2,21.7,41.1c14.4,28.8,27.1,58.4,40.5,87.6c11.9,25.8,26.9,50.3,41.6,74.7c0.2,0.4,0.4,0.9,0.8,1.3c1,1.7,2,3.4,3,5.1c2,3.4,5.5,3.1,7.7,1.1c0.2,0.1,0.5,0.2,0.8,0.3c8,2.1,20,1.5,25.2-6c5.7-8.2,0-18.3-4.6-25.6c-5.7-9-12.5-17.3-18.1-26.3c-8.5-13.7-16.7-27.5-24.8-41.4c-16.3-28-31.9-56.3-47.2-84.8c-1.1-2-2.2-4-3.2-6c1.4-0.3,2.8-1.1,3.7-2.6c12.9-21.2,35-40,60.1-44.1c6.6-1.1,13.7-0.3,19.1,3.9c4.4,3.4,7.1,8.6,9.6,13.5c4.6,9.1,9.8,18.3,19.4,23c17.1,8.2,30.3-10.9,37.3-23.5c3.8-6.9,6.8-14.2,9.9-21.5c2.1-4.8,4-9.4,7.5-13.4c4.2-4.8,9-2.3,12.7,2c6,7.1,7.6,16.8,14.7,23.2c8.9,8,21.2,4.1,28.3-4c7.7-8.8,10.3-20.8,17-30.2c9.5-13.4,23.5-22.9,33.6-35.8C480,196.6,479.3,192.6,476,190.9z M274,452.3c5.7,9.2,13,17.2,18.1,26.7c1.2,2.3,3.5,6.7,0.8,8.6c-3.5,2.5-9.4,1.8-13.3,0.8c-1.2-0.3-2.3-0.2-3.2,0.1c-0.4-0.6-0.8-1.2-1.3-1.8c0,0,0,0,0,0c-15.1-25.2-30.6-50.5-42.9-77.2c-13.3-29-26-58.4-40.3-86.9c-6.9-13.7-14.4-27.1-21.5-40.7c-7.3-14-13.2-28.5-19.8-42.9c-6.6-14.5-13.6-28.8-20.2-43.2c-6.5-14.3-12.4-28.9-18.7-43.2c-3.2-7.1-6.7-14-10.2-21c-1.1-2.1-2.1-4.3-3-6.5c-0.3-0.7-0.6-1.3-0.8-2c0,0,0-0.1,0-0.1c3.1-4.8-2.4-12.1-7.3-7.8c-0.4,0.3-0.9,0.7-1.4,1.1c-0.6,0.3-1.1,0.7-1.5,1.2c-1.9,1.3-4.1,2.4-6.1,1.6c-2.9-1-4.1-4-4.9-6.7c-2.5-8.4,2.7-15.4,9.3-19.7c6.7-4.4,17.8-8.6,25.6-4.9c3.6,1.7,5.1,6.3,5.4,10c0.2,1.7,0.4,4.9-1.2,6.2c-2.4,2-5.1,2.6-7.2,5.1c-1,1.2-1.4,2.4-1.3,3.6c-2.2,2-3,5.6-0.2,8.2c3.9,3.6,5.9,8.8,7.7,13.7c2.2,6.1,4.4,12,7.1,18c6.7,14.4,12.3,29.3,18.4,43.9c12.1,29.3,23.9,58.7,38.7,86.8C208.9,340.5,239.8,397.4,274,452.3z M269.5,251c-14.7,1.2-29.8,9.4-41.7,17.8c-11.5,8.2-20.6,18.9-28,30.7c-12.3-23.3-24.2-46.7-34.5-71.1c-9.2-21.7-18.2-43.6-27.1-65.5c-3.8-9.2-8.4-18-11.6-27.4c3,1.4,7,0.5,7.4-3.7c2.1-21.8,24.3-35.6,42.8-42.9c10.6-4.2,22.1-7,33.6-5.9c12.8,1.3,22.6,9.2,27.9,20.8c5,10.9,6.1,23.1,10.8,34c2.7,6.1,6.1,12,10.5,17c6.6,18.3,12.1,36.9,16.8,55.7c3.3,13.4,6.6,26.7,10.3,40c0.2,0.8,0.5,1.9,0.8,3.1C282.2,251.4,276.1,250.4,269.5,251z M376.2,227.8c-0.2,1-0.2,2,0,2.8c-3.4,0-6.9,1.2-10.2,3.7c-7.7,5.9-10.8,15.8-14.5,24.4c-3.4,7.9-7.1,15.6-11.7,22.8c-3.4,5.3-8.6,11.9-15.4,12c-3.9,0.1-7.8-4-10.1-6.7c-4.2-4.9-6.6-11.1-9.6-16.7c-0.4-0.7-0.8-1.4-1.2-2.1c0.9-2.3,0.2-5.2-1.7-6.7c0,0,0-0.1,0-0.1c-0.8-1.7-1.4-3.5-1.9-5.3c-1.7-5-3.1-10.2-4.5-15.3c-3.4-12.4-6.4-24.9-9.5-37.4c-3.1-12.7-6.8-25.2-10.8-37.6c7.3,2,15.5,0.4,20.9-5c6.2-6.1,6.8-16.5,7-24.6c0.5-15.3,0.7-37.6,20.3-39.9c8.1-1,16.1,2.9,22,8.3c0,0.1,0,0.1,0,0.2c7.8,21,14.7,42.2,20.3,63.9c2.8,10.9,4.6,22,6.5,33c0.8,4.8,1.7,9.6,2.6,14.3C375.6,219.5,377,224.1,376.2,227.8z M439.8,223.1c-7.1,8.1-10.9,17.7-15.8,27.1c-3.1,5.8-10,17.1-17.8,10.9c-6.1-4.9-7.9-14.2-12.3-20.5c-2.3-3.3-5.3-6-8.6-7.8c0.8-0.7,1.5-1.7,1.8-3c1.8-7.9-1.8-17.7-3.2-25.5c-2-11.3-3.7-22.7-6.3-33.9c-1.5-6.1-3.1-12.1-4.7-18.1c3.3,2,7.2,3.1,12,2.6c10.3-0.9,20.6-6.2,29.6-11c3.1-1.6,6.1-3.3,9-5.1c-3.2,5.8-5.9,12-8.1,18.3c-4.5,12.8-7.3,26.5-6.2,40.1c0.2,2.8,2.9,5.6,5.9,5.1c15.1-2.7,33.8-8.6,49.4-4.2C456.6,206.7,447.5,214.3,439.8,223.1z"/></svg>
            <span class="is-hidden-mobile">Been</span>
        </a>

        <div class="navbar-item has-dropdown is-hoverable">
            <div class="navbar-link">
                My Map
            </div>

            <div class="navbar-dropdown is-boxed">
                <a class="navbar-item" href="/user/{session?.userpage ?? 'me'}" onclick={handleMenuClick}>
                    My&nbsp;Map
                </a>
                <a class="navbar-item" href="/mymap/add" onclick={handleMenuClick}>
                    ＋&nbsp;<div class="is-hidden-mobile">Add&nbsp;</div>Visited
                </a>
                <a class="navbar-item" href="/mymap/share" onclick={handleMenuClick}>
                    Share
                </a>
                <a class="navbar-item" href="/mymap/db" onclick={handleMenuClick}>
                    Database
                </a>
            </div>
        </div>

        <div class="navbar-item has-dropdown is-hoverable">
            <div class="navbar-link">
                Top
            </div>

            <div class="navbar-dropdown is-boxed">
                <a class="navbar-item" href="/ranking/by-un/-/1" onclick={handleMenuClick}>
                    Travellers
                </a>
                <a class="navbar-item" href="/top-cities/1" onclick={handleMenuClick}>
                    Cities
                </a>
                <a class="navbar-item" href="/tcc-regions/most/1" onclick={handleMenuClick}>
                    TCC Regions
                </a>
            </div>
        </div>   
        
        <dev role="button" tabindex=0 class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navMenu"
                onclick={burger}
                onkeydown={keydownWrapper(burger)}>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
        </dev>
    </div>

    <div class="navbar-menu" id="navMenu">
        <div class="navbar-start">
            <!-- -->
        </div>

        <div class="navbar-end">
            <LoginMenu {session} bind:show_signup bind:show_login/>
        </div>
    </div>
</nav>

{#if !session?.id && (show_signup || show_login)}
<LoginSignupForm bind:show_signup bind:show_login authentication_required={authentication_required}/>
{/if}

{#if session?.deleted}
<div class="notification is-danger is-light">
    ❌ Your account is deleted. Your data will be purged {purge_after}. Before then, you can still <a href='/mymap/db'>download your data</a> or undelete your account on <a href='/settings'>the settings page</a>.
</div>
{/if}


<style>
#main-menu {
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.1rem;
    padding-bottom: 0.1rem;
    opacity: 0.9;
    transition: opacity 0.5s;
}

#main-menu:hover {
    opacity: 0.95;
}

.logo {
    font-family: "Fira Sans Condensed", sans-serif;
    text-transform: uppercase;
    font-style: oblique;
    font-size: 1.6rem;
    text-decoration-style: double !important;
    text-decoration: underline;  
}

.navbar-item:hover {
    border-radius: 6px !important;
}
.navbar-link:hover {
    border-radius: 6px !important;
}
@media screen and (max-width:1023px) {
    .navbar-brand .navbar-dropdown.is-boxed {
        border-radius: 6px;
        border-top: none;
        box-shadow: 0 8px 8px rgba(10,10,10,.1),0 0 0 1px rgba(10,10,10,.1);
        display: block;
        opacity: 0;
        pointer-events: none;
        top: calc(100% + (-4px));
        transform: translateY(-5px);
        transition-duration: 86ms;
        transition-property: opacity,transform;
    }
    .navbar-brand .navbar-dropdown {
        background-color: #fff;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
        border-top: 2px solid #dbdbdb;
        box-shadow: 0 8px 8px rgba(10,10,10,.1);
        display: none;
        font-size: .875rem;
        left: 0;
        min-width: 100%;
        position: absolute;
        top: 100%;
        z-index: 20;
    }
    .navbar.is-spaced .navbar-brand  .navbar-item.is-active .navbar-dropdown, 
    .navbar-brand .navbar-item.is-active .navbar-dropdown.is-boxed, 
    .navbar.is-spaced .navbar-brand .navbar-item.is-hoverable:focus .navbar-dropdown, 
    .navbar-brand .navbar-item.is-hoverable:focus .navbar-dropdown.is-boxed, 
    .navbar.is-spaced .navbar-brand .navbar-item.is-hoverable:focus-within .navbar-dropdown, 
    .navbar-brand .navbar-item.is-hoverable:focus-within .navbar-dropdown.is-boxed, 
    .navbar.is-spaced .navbar-brand .navbar-item.is-hoverable:hover .navbar-dropdown, 
    .navbar-brand .navbar-item.is-hoverable:hover .navbar-dropdown.is-boxed {
        opacity: 1;
        pointer-events: auto;
        transform: translateY(0);
    }
    .navbar-brand .navbar-item.is-active .navbar-dropdown, 
    .navbar-brand .navbar-item.is-hoverable:focus .navbar-dropdown, 
    .navbar-brand .navbar-item.is-hoverable:focus-within .navbar-dropdown, 
    .navbar-brand .navbar-item.is-hoverable:hover .navbar-dropdown {
        display: block;
    }
}

</style>

